import { radiansToDegrees } from '@turf/turf';
import React from 'react';
import { useSelector } from 'react-redux';

import { Attitude as AttitudeUI } from '@/components/ui/dashboard/Monitor';

const Attitude = ({ data: robotId, className }) => {
  const attitude = useSelector((state) => state.telemetry[robotId]?.attitude);

  return (
    <AttitudeUI
      roll={attitude ? radiansToDegrees(attitude.roll) : 0}
      pitch={attitude ? radiansToDegrees(attitude.pitch) : 0}
      yaw={attitude ? radiansToDegrees(attitude.yaw) : 0}
      className={className}
    />
  );
};

export default Attitude;
